import { frontendURL } from '../../../helper/URLHelper';
import DialerIndex from './pages/DialerIndex.vue';

const commonMeta = {
  permissions: ['administrator', 'agent'],
};

// Cada rota embute o Flow (/discador) num iframe. O `flowPath` diz em qual
// pagina do Flow o iframe deve abrir -- o login do Flow recebe isso como
// ?next= e navega direto para la depois de autenticar.
export const routes = [
  {
    path: frontendURL('accounts/:accountId/dialer'),
    component: DialerIndex,
    name: 'dialer_dashboard_index',
    meta: { ...commonMeta, flowPath: '/admin' },
  },
  {
    path: frontendURL('accounts/:accountId/dialer/telefonia'),
    component: DialerIndex,
    name: 'dialer_telefonia_index',
    // Dashboard central: mostra o saldo da operadora, entao e so administrador.
    meta: { permissions: ['administrator'], flowPath: '/admin/telefonia' },
  },
  {
    path: frontendURL('accounts/:accountId/dialer/ura'),
    component: DialerIndex,
    name: 'dialer_ura_index',
    // Torpedo de voz e tela de administracao: agente nao configura campanha.
    meta: { permissions: ['administrator'], flowPath: '/admin/torpedos' },
  },
];
